import styled from 'styled-components'

export const PdfContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;

  .pdf__container {
    max-height: 100%;
    width: 100vw;
    overflow-y: scroll;
  }
`

export const ButtonsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;

  .nohover:not(.fix-hover):hover {
    background-color: var(--button-background-color);
  }
`

export const ReportContainerUs = styled.iframe`
  width: 100%;
  height: 100%;
  margin-bottom: 24px;
  border: none;
`

export const PdfViewerIframe = styled.iframe`
  width: 100%;
  height: 100%;
  margin-bottom: 24px;
  border: none;
`
